export default __webpack_public_path__ + "static/media/Selling.3321ab04.png";